import { LoadingModule } from './module';
import { LoadingPage } from './page';
import { LoadingContent } from './content';

export { LoadingModule, LoadingPage, LoadingContent };
